export default class Compare {
    constructor() {
        this.bindUIActions();
        this.observeCompareFooter();
    }

    bindUIActions() {
        $(document).ready(() => {
            this.replaceSeparatorsWithLineBreaks();
            this.reorderSizes();
            this.addMobileTitleToTableRows();
            this.appendButtonsToTable();
            this.checkActiveClass();
        });
    }

    replaceSeparatorsWithLineBreaks() {
        // In the Layers, Size and Tension columns, replace the separators with line breaks
        $('tr._layers_ td, tr._size_ td, tr._tension_ td, tr._drawer-options_ td').each(function () {
            const originalText = $(this).find('span').text();
            const updatedText = originalText.replace(/\s*[\|,]\s*/g, '<br>');
            $(this).find('span').html(updatedText);
        });
    }

    reorderSizes() {
        // Get all the spans containing mattress sizes except the first one
        const sizeSpans = document.querySelectorAll('._size_ span:not(:first-child)');

        // Define the size order
        const sizeOrder = [
            "Single Size",
            "Small Double Size",
            "Double Size",
            "King Size",
            "King Size Zip &amp; Link",
            "Super King Size",
            "Super King Size Zip &amp; Link",
            "Extra King Size Zip &amp; Link"
        ];

        // Iterate over size spans
        sizeSpans.forEach(span => {
            // Extract the sizes from the span and split them by <br>
            const sizes = span.innerHTML.trim().split('<br>').map(size => size.trim());

            // Reorder the sizes within this span
            const reorderedSizes = sizeOrder.filter(size => sizes.includes(size));

            // Update the innerHTML of the span with reordered sizes
            span.innerHTML = reorderedSizes.join('<br>');
        });
    }

    addMobileTitleToTableRows() {
        // Add the class name as a title to the mobile version of the table
        $('.product-table-configure tr').each((index, element) => {
            const className = $(element).attr('class');
            if (className) {
                const title = className.substring(1).replace(/[^a-zA-Z]/g, ' ');
                $(element).find('.mobile-title').text(title);
            }
        });
    }

    appendButtonsToTable() {
        // Append 'Add To Basket' buttons to the table
        const urls = [];
        $('.product-table-configure tbody tr:first-child').find('.img_ a').each(function() {
            urls.push($(this).attr('href'));
        });

        let newRow = '<tr>';
        // Check if the parent table has the class "th-desktop-type-displey"
        if ($('.product-table-configure').hasClass('th-desktop-type-displey')) {
            newRow += '<td></td>';
        }
        for (let i = 0; i < urls.length; i++) {
            newRow += '<td><a class="btn btn--black btn--md" target="_blank" href="' + urls[i] + '">Add To Basket</a></td>';
        }
        newRow += '</tr>';

        $('.product-table-configure tbody').append(newRow);
    }

    checkActiveClass() {
        // Call the above functions if the compare popup is active
        const intervalID = setInterval(() => {
            const activeClassNow = $('#th-compare-output-wrap').hasClass('active');
            if (activeClassNow && !this.activeClassPresent) {
                // Active class was added
                this.activeClassPresent = true;
                this.replaceSeparatorsWithLineBreaks();
                this.reorderSizes();
                this.addMobileTitleToTableRows();
                this.appendButtonsToTable();
            } else if (!activeClassNow && this.activeClassPresent) {
                // Active class was removed
                this.activeClassPresent = false;
            }
        }, 100);
    }

    observeCompareFooter() {
        this.updateCompareFooter();

        setInterval(() => this.updateCompareFooter(), 1000);

        const observer = new MutationObserver(mutations => {
            let shouldUpdate = false;
            mutations.forEach(mutation => {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    shouldUpdate = true;
                }
            });

            if (shouldUpdate) {
                this.updateCompareFooter();
            }
        });

        const targetNode = document.querySelector('.th-compare-footer-wrap');
        if (targetNode) {
            observer.observe(targetNode, { childList: true, subtree: true, attributes: true });
        }
    }

    updateCompareFooter() {
        const footerWrap = document.querySelector('.th-compare-footer-wrap');
        if (!footerWrap) {
            return;
        }

        const products = footerWrap.querySelectorAll('.product_image .img_');

        const compareWrapper = document.querySelector('.th-compare-enable');
        if (!compareWrapper) {
            return;
        }

        let compareButton = compareWrapper.querySelector('.th-compare-footer-product-opner');
        let label = document.querySelector('.compare-label');

        if (!label) {
            label = document.createElement('span');
            label.id = 'compare-label';
            label.classList.add('compare-label');
            label.textContent = 'Add another product to compare';
        }

        if (products.length < 2) {
            compareButton.style.display = 'none';
            if (!compareWrapper.contains(label)) {
                compareWrapper.appendChild(label);
            }
        } else {
            compareButton.style.display = '';
            if (compareWrapper.contains(label)) {
                compareWrapper.removeChild(label);
            }
        }
    }
}

new Compare();